<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{$t('societes.listeAgence')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="card card-honrizontal "
               :class="{'mgt-20px': $index !== 0}"
               v-for="(agence, $index) in societe.agences" :key="agence.id">
            <div class="columns is-vcentered is-marginless" >
              <div class="column is-3">
                <div>
                  <span class="has-text-weight-bold is-size-4 has-text-link">
                    {{agence.libelle }}
                  </span>
                </div>
                <span v-if="$route.name === 'c.parametrage.societe/agence'"
                      class="is-italic is-size-7 has-text-secondary-icon">
                  {{ agence.codeAgence}}
                </span>
                <router-link-blank v-else
                  :to="{ name: 'c.parametrage.societe/agence',
                  params: {id: agence.idSociete}}"
                  :message="agence.libelleSociete"/>
              </div>
              <div class="column is-5">
                <span class="has-text-default">
                  {{getAddress(agence.adresse)}}
                </span>
              </div>
              <div class="column is-3">
                <span class="has-text-default">
                  {{agence.telephone}}
                </span>
              </div>
              <div class="column is-1" v-if="editable">
                <div class="columns">
                  <div class="column is-6">
                    <div class="has-text-centered">
                      <a @click="checkPermissions(permSocietes.maj) ?
                        $router.push({name: 'm.parametrage.societe/agence-modificationAgence',
                        params: { societeId: societe.id, agenceId: agence.id}})
                        : showPopUp()">
                        <b-icon icon="pencil-box-outline" type="is-success"
                                :class="{
                                'text-access-no-permission' :
                                !checkPermissions(permSocietes.maj)}"></b-icon>
                      </a>
                    </div>
                  </div>
                  <div class="column is-6">
                    <div class="has-text-centered">
                      <a @click="inProgress()">
                        <b-icon icon="delete-forever" type="is-danger"
                                :class="{
                                'text-access-no-permission' :
                                !checkPermissions(permSocietes.supprimer)}"></b-icon>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { SOCIETES } from '@/configuration/general/permissionsParametrageConf';
import inProgress from '@/services/general/inProgress';
import routerLinkBlank from '@/components/general/routerLinkBlank';

const permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    routerLinkBlank,
  },
  data() {
    return {
      permSocietes: SOCIETES,
    };
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    getAddress(addressAgence) {
      return adressFullStringGetter(addressAgence);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
  },
};
</script>
